import React from "react";
import { Button, Form } from "react-bootstrap";
import { CYDCSLogo } from "../../images";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../components";
import { loginFormValidations } from "../../helpers/formValidation";
import { useForm } from "../../hooks/useForm";
import { reqToUserLogin } from "../../store/slice/userSlice";

const AdminLogin = () => {
  const dispatch = useDispatch();
  const { loader } = useSelector((state) => state.userReducer);

  const initialValues = {
    username: "",
    password: "",
    type: "ADMIN",
  };
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    return loginFormValidations(
      fieldValues,
      temp,
      values,
      setValues,
      setErrors
    );
  };
  const { errors, setErrors, values, setValues, handleInputChange } = useForm(
    initialValues,
    true,
    validate
  );

  const handleUserLogin = (e) => {
    e.preventDefault();
    if (!validate()) return;
    dispatch(reqToUserLogin({ data: values }));
  };

  return (
    <>
      {loader && <Loader />}
      <div className="lms-login-section">
        <div className="lms-navbar"></div>
        <div className="lms-login-content">
          <Form className="lms-login-form lms-admin-login">
            <div className="lms-login-form-box">
              <div className="lms-login-logo">
                <div className="lms-logo">
                  <img className="lms-brand-logo" src={CYDCSLogo} alt="Brand" />
                </div>
                <div className="logo-title">
                  <h2 className="text-center">
                    ADMIN <span>APP</span>
                  </h2>
                </div>
                <div className="version lms_version_content">
                  <p>
                    {process.env.REACT_APP_SERVER} Version{" "}
                    {process.env.REACT_APP_VERSION}
                  </p>
                </div>
              </div>
              <Form.Group className="lms-login-form-list">
                <div className="lms-login-form-list-input mb-2">
                  <Form.Control
                    type="text"
                    name="username"
                    placeholder="Username"
                    autoComplete="off"
                    className="text-center"
                    value={values?.username}
                    onChange={handleInputChange}
                  />
                  <span className="lms_error_text">
                    {errors && errors.username}
                  </span>
                </div>
              </Form.Group>
              <Form.Group className="lms-login-form-list">
                <div className="lms-login-form-list-input">
                  <Form.Control
                    type="password"
                    name="password"
                    placeholder="Password"
                    autoComplete="off"
                    className="text-center"
                    value={values?.password}
                    onChange={handleInputChange}
                  />
                  <span className="lms_error_text">
                    {errors && errors.password}
                  </span>
                </div>
              </Form.Group>
              <div className="text-center">
                <Button
                  variant="primary"
                  className="lms-login-button mt-5"
                  type="submit"
                  onClick={handleUserLogin}
                >
                  Login
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </Button>
              </div>
            </div>
          </Form>
        </div>
        <div className="lms-footer-blank d-flex justify-content-center"></div>
      </div>
    </>
  );
};

export default AdminLogin;
